module.exports = __webpack_public_path__ + "media/images/countryrect/me-80ee67294f8a2c244e86b4fec643d0a0.svg";